import { formatPrice } from '@posilka/shared';
import { useState } from 'react';

/**
 * Narx kiritish. Tahrirlash paytida — faqat raqamlar (formatlash kursorni sakratib, mobil
 * klaviaturada "qotib qolgan" effekt beradi), fokusdan chiqqanda — `65 000` ko'rinishi,
 * 1000 ga yaxlitlash va [min, max] oraliqqa keltirish.
 */
export function PriceInput({
  value,
  onChange,
  min,
  max,
  currency,
  invalid,
  label,
}: {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  min: number;
  max: number;
  currency: string;
  invalid?: boolean;
  label: string;
}) {
  const [draft, setDraft] = useState<string | null>(null);
  const editing = draft !== null;

  return (
    <label
      className="input mb-3 flex cursor-text items-center justify-center gap-2 py-2"
      aria-invalid={invalid}
    >
      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        enterKeyHint="done"
        autoComplete="off"
        aria-label={label}
        className="w-48 bg-transparent text-center font-display text-3xl font-bold outline-none"
        value={editing ? draft : value === undefined ? '' : formatPrice(value, '').trim()}
        onFocus={(e) => {
          setDraft(value === undefined ? '' : String(value));
          // Mobil'da fokus bilan butun qiymat tanlansin — darhol yangi narx yozish oson.
          const el = e.currentTarget;
          requestAnimationFrame(() => el.select());
        }}
        onChange={(e) => {
          const digits = e.target.value.replace(/\D/g, '').slice(0, 9);
          setDraft(digits);
          onChange(digits ? Number(digits) : undefined);
        }}
        onBlur={() => {
          setDraft(null);
          if (value === undefined) return;
          const rounded = Math.round(value / 1000) * 1000;
          onChange(Math.min(max, Math.max(min, rounded)));
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') e.currentTarget.blur();
        }}
      />
      <span className="text-lg text-hint">{currency}</span>
    </label>
  );
}
